/**
 * recoverMessage — EINE reine Funktion, die entscheidet, was der „Prüfen"-Knopf meldet.
 *
 * Warum es das braucht (Befund 14.08.2026): Der Owner klickte bei einem KERNGESUNDEN
 * LinkedIn auf „Prüfen" und bekam als grüne Erfolgsmeldung
 *
 *     „LinkedIn: Verbindung geprüft — Unbekanntes Problem — bitte Support kontaktieren"
 *
 * Er verstand das als „der Support wurde über ein Anmeldeproblem informiert" — verständlich,
 * und in jeder Hinsicht falsch: Der Kanal war `ready_to_post` mit `error_type=none`
 * (Server-Log 13:25:32 UTC), es gab kein Problem, und es wurde niemand informiert.
 *
 * Die Ursache liegt im Backend: `get_recovery_action()` fällt für jeden Fall, den es nicht
 * ausdrücklich kennt, auf `contact_support` mit dem Text „Unbekanntes Problem" zurück —
 * auch für den Fall „alles in Ordnung, es gibt nichts zu reparieren". Das Frontend hat
 * diesen Text ungeprüft in eine ERFOLGS-Meldung eingesetzt.
 *
 * Repariert wird hier und nicht im Backend, weil die Antwort alles Nötige bereits mitliefert:
 * `previous_status` sagt, wie es dem Kanal geht. Ein gesunder Kanal bekommt eine ehrliche
 * Entwarnung, und nur ein wirklich defekter darf zum Support schicken.
 */

/** Zustände, in denen ein Kanal gesund ist — gespiegelt aus PlatformStatus (Backend). */
const GESUND = ["connected", "ready_to_post"];

/**
 * @param name            Anzeigename des Kanals, z. B. "LinkedIn"
 * @param action          `recovery_action` aus POST /social-connect/recover/{platform}
 * @param previousStatus  `previous_status` aus derselben Antwort
 * @returns {{ tone: 'success'|'info', text: string }}
 */
export function recoverMessage(name, action, previousStatus) {
  const art = action?.action;
  const beschreibung = (action?.description || "").trim();

  if (GESUND.includes(previousStatus)) {
    // Ein gesunder Kanal hat nichts zu reparieren. Die Beschreibung des Backends ist
    // hier bestenfalls belanglos und schlimmstenfalls („Unbekanntes Problem") eine
    // Falschmeldung — sie wird bewusst verworfen.
    return { tone: "success", text: `${name}: Verbindung geprüft — alles in Ordnung.` };
  }

  if (art === "contact_support") {
    // Jetzt ist es ehrlich: Der Kanal ist NICHT gesund und wir wissen nicht, warum.
    return {
      tone: "info",
      text: `${name}: Die Prüfung konnte den Zustand nicht klären. Bitte melde dich bei uns — es wurde noch niemand benachrichtigt.`,
    };
  }

  return {
    tone: "success",
    text: `${name}: Verbindung geprüft — ${beschreibung || "alles in Ordnung"}`,
  };
}
